import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription, switchMap } from 'rxjs';
import { StationService } from '../../../../../services/station.service';
import { SharedService } from '../../../../../services/shared.service';
import { MESSAGE } from '../../../../../utils/messages';
import { UserService } from '../../../../../services/user.service';
import { Station } from '../../../../../models/stations.model';
import { User, UserStation } from '../../../../../models/user.model';
import { GridModal } from '../../../../../models/grid-modal';

@Component({
  selector: 'app-user-station',
  templateUrl: './user-station.component.html',
  styleUrls: ['./user-station.component.scss'],
})
export class UserStationComponent implements OnInit, OnDestroy {
  allStations$: Observable<Station[]> = this.stationService.getLicensed();
  isFormSubmitted: boolean = false;
  userStationForm: FormGroup = this.fb.group({
    selectedStation: ['', Validators.required],
  });
  userStations: UserStation[];
  displayedColumns = ['NAZIV STANICE', 'AKCIJE'];
  subscription: Subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: GridModal<User>,
    private stationService: StationService,
    public sharedService: SharedService,
    public dialogRef: MatDialogRef<UserStationComponent>,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.userStations = this.data.content.userStations;
  }

  onClickAddStation() {
    this.isFormSubmitted = true;
    if (!this.userStationForm.valid) {
      this.sharedService.showMessage(MESSAGE.error_user_station_input);
      return;
    }
    if (this.userStationForm.get('selectedStation')?.value) {
      this.subscription.add(
        this.userService
          .postUserStation(this.data.id, {
            stationId: this.userStationForm.get('selectedStation')?.value.id,
          })
          .pipe(switchMap(() => this.userService.getById(this.data.id)))
          .subscribe({
            next: res => {
              this.userStations = res.userStations;
              this.sharedService.openSnackBar(MESSAGE.success_put);
            },
            error: errorMessage => {
              errorMessage.appCode
                ? this.sharedService.showMessage(errorMessage.appCode)
                : this.sharedService.showMessage(MESSAGE.error_user_stations_save);
            },
          }),
      );
    }
  }

  removeUserStation(id: number) {
    this.subscription.add(
      this.userService
        .deleteUserStation(id)
        .pipe(switchMap(() => this.userService.getById(this.data.id)))
        .subscribe({
          next: res => {
            this.userStations = res.userStations;
            this.sharedService.openSnackBar(MESSAGE.success_delete);
          },
          error: errorMessage => {
            errorMessage.appCode
              ? this.sharedService.showMessage(errorMessage.appCode)
              : this.sharedService.showMessage(MESSAGE.error_user_stations_delete);
          },
        }),
    );
  }

  closeModal() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
